import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

function RedirectIfAuth({ children }) {
  const { user } = useAuth();
  if (user) {
    // If user is logged in, redirect them to the homepage
    return <Navigate to="/" replace />;
  }
  return children;
}
export default RedirectIfAuth;
